<template>
	<template v-if="appendTo === 'body'">
        <button @click="toggleDropdownMenu" v-bind="$attrs">
            <slot name="dropdown-button">
                <BaseIcon name="more_horiz_outlined" size="20"/>
            </slot>
        </button>
        <Popover class="dropdown-menu-box shadow-sidebar-more rounded-base" :style="{'marginStart': offsetX+'px', 'marginTop': offsetY+'px'}" ref="dropdown_menu" @click="handleClickOverlayPanel" @hide="closeDropdownMenu">        
            <slot name="dropdown-content"></slot>
        </Popover>
    </template>
	<div v-else class="inline-block relative">
		<button ref="dropdown_btn" @click="toggleDropdownMenu">
			<slot name="dropdown-button">
				<BaseIcon name="more_horiz_outlined" size="20"/>
			</slot>
		</button>
		<div v-if="isShown" class="dropdown-menu-box bg-white border border-white p-2 shadow-sidebar-more rounded-base z-10 absolute dark:bg-dark-web-wash dark:border-white/10" ref="dropdown_menu" v-click-outside="closeDropdownMenu" @click.stop="handleClickOverlayPanel"
			:style="{
				top: caretPosition.top !== null ? `${caretPosition.top}px` : 'auto',
				right: caretPosition.right !== null ? `${caretPosition.right}px` : 'auto',
				bottom: caretPosition.bottom !== null ? `${caretPosition.bottom}px` : 'auto',
				left: caretPosition.left !== null ? `${caretPosition.left}px` : 'auto',
			}">
			<slot name="dropdown-content"></slot>
		</div>
	</div>
</template>

<script>
import Popover from 'primevue/popover';
import BaseIcon from '@/components/icons/BaseIcon.vue';

export default {
	components: { Popover, BaseIcon },
	data() {
		return {
			isShown: false,
			caretPosition: {
				top: null,
				right: null,
				bottom: null,
				left: null
			},
			measuredWidth: null,
			measuredHeight: null
		}
	},
	props: {
		offsetX: {
            type: Number,
            default: 0
        },
        offsetY: {
            type: Number,
            default: 5
        },
		appendTo: {
            type: String,
            default: 'body'
        },
		closeWhenSelect: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		measureDropdown() {
			const dropdown = this.$refs.dropdown_menu;
			this.measuredWidth = dropdown.offsetWidth;
			this.measuredHeight = dropdown.offsetHeight;
		},
		toggleDropdownMenu(e){
			if(this.appendTo === 'body'){
				this.$refs.dropdown_menu.toggle(e);
			} else {
				this.isShown = !this.isShown;
				this.$nextTick(() => {
					if (this.isShown && !this.measuredWidth) {
						this.measureDropdown();
					}
					this.updateCaretPosition();
				});
			}
			this.$emit('toggle_menu');
		},
		closeDropdownMenu(e) {
			if(this.appendTo === 'body'){
				this.$refs.dropdown_menu.hide(e);
			} else {
				this.isShown = false;
			}
			this.$emit('close_menu');
		},
		updateCaretPosition () {
			const dropdownButtonRect = this.$refs.dropdown_btn.getBoundingClientRect()

			// set X coordinate overlay panel
			if((window.innerWidth - dropdownButtonRect.left) > this.measuredWidth){
				this.caretPosition.left = this.offsetX
				this.caretPosition.right = null
			}else{
				this.caretPosition.right = this.offsetX
				this.caretPosition.left = null
			}

			// set Y coordinate overlay panel
			if((window.innerHeight - dropdownButtonRect.top) > this.measuredHeight){
				this.caretPosition.top = dropdownButtonRect.height + Number(this.offsetY)
				this.caretPosition.bottom = null
			}else{
				this.caretPosition.bottom = dropdownButtonRect.height + Number(this.offsetY)
				this.caretPosition.top = null
			}
		},
		handleClickOverlayPanel(){
			this.closeWhenSelect && this.closeDropdownMenu()
		}
	},
	emits: ['toggle_menu', 'close_menu']
}
</script>
